var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mainContainer" },
    [
      _c(
        "el-table",
        {
          ref: "plxTable",
          attrs: {
            data: _vm.tableData,
            "max-height": "500",
            "highlight-current-row": "",
            border: "",
            stripe: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "评价月",
              prop: "month",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              align: "center",
              label: "Category2",
              prop: "category2Name",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              align: "center",
              label: "Facility编号",
              prop: "facilityCode",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              align: "center",
              label: "Facility名称",
              prop: "facilityName",
              "min-width": "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "等级",
              prop: "grade",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "分数",
              prop: "score",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              align: "center",
              label: "Comment",
              prop: "remark",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              align: "center",
              label: "截止日期",
              prop: "deadline",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "状态",
              prop: "statusI18n",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              align: "center",
              label: "更新人",
              prop: "updateName",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              align: "center",
              label: "更新日期",
              prop: "updateDate",
              "min-width": "100",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }